export const ageOptions = [
  { label: 'Dorosły', value: 'adult' },
  { label: 'Dziecko', value: 'child' },
]
